/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Documents from "./Documents";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type DocumentBoxProps = {
  product: AbstractCase;
  headline?: string;
};

const DocumentBox = ({ product, headline = "Meine Dokumente" }: DocumentBoxProps) => {
  if (!product.isCustomerDataCompleted) {
    return null;
  }

  return (
    <ProductBox headline={headline}>
      <Documents product={product} />
    </ProductBox>
  );
};

export default DocumentBox;
